// Result: Sep 13

export const createdUpdatedAtShort = (date: string) => {
    return new Date(date).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
    })
}
